import { useState } from 'react';
import { ChevronRight } from 'lucide-react';
import { getUserColor, getRoleBadgeColor, getDisplayRole } from '@/utils/calendarHelpers';
import { ROLE_COLORS } from '@/utils/constants';
import { EarningsSummary } from './EarningsSummary';

interface TeamMemberCardProps {
  member: any;
  monthHours: number;
}

export function TeamMemberCard({ member, monthHours }: TeamMemberCardProps) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div
      className="bg-slate-800 border border-slate-700 rounded-xl overflow-hidden"
      style={{
        borderLeftColor: getUserColor(member, undefined as any),
        borderLeftWidth: (member.color || ROLE_COLORS[member.role]) ? '3px' : undefined,
      }}
    >
      <button
        onClick={() => setExpanded(!expanded)}
        data-testid={`toggle-team-member-${member.id}`}
        className="w-full p-4 flex items-center gap-3 text-left hover:bg-slate-750 transition-colors"
      >
        {member.emoji ? (
          <div
            className="w-10 h-10 rounded-full flex items-center justify-center text-xl flex-shrink-0"
            style={{ backgroundColor: `${getUserColor(member, '#3b82f6')}30` }}
          >
            {member.emoji}
          </div>
        ) : (
          <div
            className="w-10 h-10 rounded-full flex items-center justify-center text-white font-semibold text-sm flex-shrink-0"
            style={{ backgroundColor: getUserColor(member, '#3b82f6') }}
          >
            {`${member.first_name.charAt(0)}${member.last_name?.charAt(0) || ''}`.toUpperCase()}
          </div>
        )}
        <div className="flex-1 min-w-0">
          <h3 className="text-white font-medium truncate">{member.first_name} {member.last_name || ''}</h3>
          <span className={`inline-block text-xs px-2 py-0.5 rounded ${getRoleBadgeColor(member.role)}`}>
            {getDisplayRole(member.role)}
          </span>
        </div>
        <div className="text-right mr-2">
          <div className="text-white font-medium">{monthHours.toFixed(1)}</div>
          <div className="text-xs text-gray-400">hrs this mo.</div>
        </div>
        <ChevronRight
          size={18}
          className={`text-gray-400 transition-transform flex-shrink-0 ${expanded ? 'rotate-90' : ''}`}
        />
      </button>
      {expanded && (
        <div className="px-4 pb-4 border-t border-slate-700">
          <EarningsSummary userId={member.id} userRole={member.role} hourlyWage={member.hourly_wage ?? undefined} viewingOther compact />
        </div>
      )}
    </div>
  );
}
